






export default {
  props: {
    text: {
      required: true,
      type: String
    }
  }
};
